angular.module('hjApp').service('ModalGrantSupportAccess', [
    '$modal',
    function ($modal) {
        this.show = function () {
            return $modal.open({
                templateUrl: 'modal-grant-support-access.html',
                controller: 'ModalGrantSupportAccessCtrl',
                backdrop: 'static',
                windowClass: 'modal-500 modal-grant-support-access'
            });
        };
    }
]);
